import styled from 'styled-components';

import { ReactComponent as PlaceholderIcon } from '@/assets/icons/img-placeholder.svg';
import Text from '@/components/Text';

const Placeholder = styled.div`
  padding: 24px;
  padding-top: 32px;
`;

const PlaceholderHolder = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 144px;
  border: 1px solid ${({ theme }) => theme.colors.grayscaleLight};
  svg {
    width: 22px;
  }
`;

const ImagesPlaceholder = () => {
  return (
    <Placeholder>
      <PlaceholderHolder $color="gray" $type="caption">
        <PlaceholderIcon /> No images found
      </PlaceholderHolder>
    </Placeholder>
  );
};

export default ImagesPlaceholder;
